module.exports = __webpack_public_path__ + "fonts/TheSansVeolia-W5Pla.f8f36b01.otf";